"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _css = require("@emotion/css");
var _react = require("react");
var _hooks = require("../../hooks");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
const useStyles = function (layout) {
  let isDragOver = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const {
    fontFamily,
    themeColors,
    basicFontSize,
    direction
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    pxToRem
  } = (0, _hooks.useStylesUtils)();
  const ccUploaderStyle = (0, _react.useMemo)(() => {
    const uploaderHiddenInput = () => {
      if (layout === 'button') {
        return {};
      }
      return {
        width: '100%',
        height: '100%',
        left: 0,
        top: 0
      };
    };
    const deviceProps = () => {
      const height = isMobileView ? '100%' : 'auto';
      return {
        height
      };
    };
    const drop = (0, _css.css)({
      position: 'relative',
      ...deviceProps()
    });
    const dropZone = (0, _css.css)({
      fontFamily: fontFamily,
      borderRadius: pxToRem(10),
      border: `2px dashed ${themeColors?.general.subText}`,
      color: themeColors?.general.text,
      fontSize: basicFontSize,
      backgroundColor: isDragOver ? themeColors?.basic.main : themeColors?.basic.light,
      textAlign: 'center',
      ...deviceProps()
    });
    const hiddenInput = (0, _css.css)({
      position: 'absolute',
      opacity: 0,
      ...uploaderHiddenInput()
    });
    const title = (0, _css.css)({
      fontSize: pxToRem(26),
      fontWeight: 700,
      marginBlock: pxToRem(20),
      color: themeColors?.general.subText
    });
    const or = (0, _css.css)({
      marginBottom: pxToRem(20),
      color: themeColors?.general.subText
    });
    const limits = (0, _css.css)({
      margin: `${pxToRem(60)} ${pxToRem(20)} ${pxToRem(20)}`,
      display: 'flex',
      justifyContent: 'center',
      direction,
      span: {
        display: 'inline-block',
        marginInlineEnd: pxToRem(2)
      }
    });
    const limitsSecond = (0, _css.css)({
      marginInlineStart: pxToRem(10)
    });
    const error = (0, _css.css)({
      fontSize: pxToRem(12),
      margin: pxToRem(20)
    });
    return {
      drop,
      dropZone,
      hiddenInput,
      title,
      or,
      limits,
      limitsSecond,
      error
    };
  }, [basicFontSize, direction, fontFamily, isDragOver, isMobileView, layout, pxToRem, themeColors?.basic.light, themeColors?.basic.main, themeColors?.general.subText, themeColors?.general.text]);
  return {
    'cc-Uploader__drop': ccUploaderStyle.drop,
    'cc-Uploader__drop-zone': ccUploaderStyle.dropZone,
    'cc-Uploader__hidden-input': ccUploaderStyle.hiddenInput,
    'cc-Uploader__title': ccUploaderStyle.title,
    'cc-Uploader__or': ccUploaderStyle.or,
    'cc-Uploader__limits': ccUploaderStyle.limits,
    'cc-Uploader__limits__second': ccUploaderStyle.limitsSecond,
    'cc-Uploader__error': ccUploaderStyle.error
  };
};
exports.useStyles = useStyles;